import React from 'react';

/* mui */
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
/* mui */

/* CONSTANTS */
const useStyles = makeStyles(theme => ({
  paper: {
    backgroundColor: "#fff",
    padding: theme.spacing(3),
    textAlign: 'left',
    color: "#007837",
    marginTop: 15,
    marginBottom: 15,
    fontFamily: 'open_sansregular,Helvetica,Arial,sans-serif',
    // backgroundColor: "#fff",
    // backgroundSize: "cover",
    // backgroundImage: "url(https://thq-mj-countdown.s3-ap-southeast-2.amazonaws.com/assets/countdown/Background+Colour.png)"
    // width: "374px !important",
 
  }
}));
/* CONSTANTS */

const wrapper = props => {

  /* mui */
  const classes = useStyles();
  /* mui */

  return <Paper className={classes.paper}>
    { props.children }
  </Paper>
}

export default wrapper;
